import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import { BOOKING_REQUESTS_URL } from "./constants";

export function useInvalidateBookingRequests() {
  const queryClient = useQueryClient();

  return useCallback(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    queryClient.invalidateQueries({
      predicate: (query) =>
        (query.queryKey?.[0] as string | undefined)?.includes(BOOKING_REQUESTS_URL) ?? false,
    });
  }, [queryClient]);
}
